
  import { defineComponent, ref, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';

  export default defineComponent({
    name: 'admins-filter',
    emit: ['type-selected', 'reset'],
    setup(_, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();

      const selectedItems = ref<any>({
        email: '',
        roleId: '',
      });

      const translate = (text: string) => (te(text) ? t(text) : text);

      const onSubmit = async () => {
        await store.dispatch(Actions.UPDATE_ADMIN_FILTER, selectedItems.value);
        emit('type-selected', selectedItems.value);
      };

      const onReset = async () => {
        selectedItems.value = { roleId: '', email: '' };
        await store.dispatch(Actions.UPDATE_ADMIN_FILTER, selectedItems.value);
        emit('reset', selectedItems.value);
      };

      const filter = computed(() => store.getters.getAdminFilters || {});
      onMounted(async () => {
        await store.dispatch(Actions.GET_ALL_ROLES);
        if (filter.value?.roleId)
          selectedItems.value.roleId = filter.value.roleId;
        if (filter.value?.email && filter.value.email !== 'undefined')
          selectedItems.value.email = filter.value.email;
      });

      return {
        selectedItems,
        onSubmit,
        onReset,
        translate,
        allRoles: computed(() => store.getters.getAllRolesListing),
      };
    },
  });
